// Instagram Reels — used as official oEmbed iframes.
// Thumbnails are provided natively by Instagram inside the embed.
export const REELS = [
  { id: "DC0AjxyMnVN" },
  { id: "DUd04qxkZsa" },
  { id: "DRP8x-vid5T" },
  { id: "DQYImbDjOXm" },
  { id: "DVpEDEGker9" },
  { id: "DMNngHyMbWc" },
  { id: "DSc6lKbEcvN" },
  { id: "DSpysNGERgH" },
  { id: "DFN6MVPpibg" },
  { id: "DPhzNDQjOOs" },
  { id: "DVi9yVrjgYG" },
  { id: "DVTq4pwAJvM" },
  { id: "DSLlQ-ZkQzq" },
  { id: "DX-eqi4K53k" },
  { id: "DYKSmyOx2O5" },
  { id: "DYA6sjYJ4EW" },
];

export const HELLO_CLIPS = [
  "/assets/hello-1.mp4",
  "/assets/hello-2.mp4",
  "/assets/hello-3.mp4",
  "/assets/hello-4.mp4",
  "/assets/hello-5.mp4",
];

export const SERVICE_TAGS = [
  { label: "activaciones", color: "purple" },
  { label: "marketing", color: "purple" },
  { label: "films", color: "purple" },
  { label: "asesoría creativa", color: "purple" },
  { label: "gestión de redes", color: "fuchsia" },
  { label: "eventos", color: "purple" },
  { label: "desarrollo web", color: "purple" },
  { label: "diseño gráfico", color: "purple" },
];

export const PROCESS_STEPS = [
  { n: 1, title: "Conectamos contigo", desc: "Nos contactas y nos cuentas de qué va tu proyecto, qué estás construyendo y hacia dónde quieres llevar tu marca." },
  { n: 2, title: "Estudiamos tu marca", desc: "Analizamos tu negocio, identificamos oportunidades y te devolvemos una propuesta pensada estratégicamente para ti." },
  { n: 3, title: "Creamos tu base estratégica", desc: "Cuando apruebas, desarrollamos nuestro Modo system®: 5 documentos base que le dan dirección a tu marca.", bullets: [
    "Cómo se ve tu marca",
    "Cómo suena tu marca",
    "Concepto estratégico",
    "Pilares de contenido",
    "La estructura de contenido a desarrollar",
  ] },
  { n: 4, title: "Inicia la magia", desc: "Agendamos la pauta, organizamos la ejecución y comenzamos a llevar tu marca al lugar donde siempre quiso estar." },
];

export const CONTACT = {
  instagram: "https://www.instagram.com/modoredes",
  whatsapp: "https://wa.link/ht4il3",
  email: "modoredes07@gmail.com",
};

export const NAV_ITEMS = [
  { id: "hello", label: "hello" },
  { id: "modos", label: "modos" },
  { id: "videos", label: "videos" },
  { id: "contacto", label: "contáctanos" },
];
